const arts = [
  {
    id: 1,
    title: "3ddd Arts",
    title_item: "3ddd Arts",
    description: (
      <>
        These models and compositions are made especially for{" "}
        <a href="https://3ddd.ru/" target="_blank" rel="noopener noreferrer">
          3ddd.ru
        </a>{" "}
        or{" "}
        <a href="https://3dsky.org/" target="_blank" rel="noopener noreferrer">
          3dsky.org
        </a>
        .<br />
        Models can be purchased and downloaded on my page -{" "}
        <a
          href="https://3dsky.org/users/morosow/models"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://3dsky.org/users/morosow/models
        </a>
        . Models include textures.
      </>
    ),
    Year: "Year: 2013-2018",

    image: "/images/Arts_3ddd/Straftäter.jpg",
    images: [
      "/images/Arts_3ddd/alter_Spiegel.jpg",
      "/images/Arts_3ddd/Antiquität.jpg",
      "/images/Arts_3ddd/Antiquität_22.jpg",
      "/images/Arts_3ddd/Balance.jpg",

      "/images/Arts_3ddd/Antiquität_24.jpg",
      "/images/Arts_3ddd/Antiquität_23.jpg",

      "/images/Arts_3ddd/Balance_3.jpg",
      "/images/Arts_3ddd/Balance_4.jpg",
      "/images/Arts_3ddd/Bestellung.jpg",
      "/images/Arts_3ddd/Billard.jpg",
      "/images/Arts_3ddd/Billard_2.jpg",
      "/images/Arts_3ddd/Casanova.jpg",
      "/images/Arts_3ddd/Church.jpg",
      "/images/Arts_3ddd/Church_2.jpg",
      "/images/Arts_3ddd/Decor.jpg",
      "/images/Arts_3ddd/Decor_2.jpg",
      "/images/Arts_3ddd/Decor_3.jpg",
      "/images/Arts_3ddd/Dorftisch.jpg",
      "/images/Arts_3ddd/Dorftisch_2.jpg",
      "/images/Arts_3ddd/Gänseblümchen.jpg",
      "/images/Arts_3ddd/gargoyle.jpg",
      "/images/Arts_3ddd/gargoyle_2.jpg",
      "/images/Arts_3ddd/gargoyle_3.jpg",
      "/images/Arts_3ddd/Gottesanbeterin.jpg",
      "/images/Arts_3ddd/Gottesanbeterin_2.jpg",
      "/images/Arts_3ddd/Halloween.jpg",
      "/images/Arts_3ddd/Halloween_3.jpg",
      "/images/Arts_3ddd/Halloween_4.jpg",
      "/images/Arts_3ddd/Halloween_5.jpg",
      "/images/Arts_3ddd/KeyStone.jpg",
      "/images/Arts_3ddd/Küche.jpg",
      "/images/Arts_3ddd/Licht.jpg",
      "/images/Arts_3ddd/Lion.jpg",
      "/images/Arts_3ddd/Roller.jpg",
      "/images/Arts_3ddd/Roller_2.jpg",
      "/images/Arts_3ddd/Sphinx.jpg",
      "/images/Arts_3ddd/Spielzeug.jpg",
      "/images/Arts_3ddd/Straftäter.jpg",
      "/images/Arts_3ddd/lamplight fish.jpg",
    ],
    categoryId: 1,
  },
  {
    id: 2,
    title: "Blender Arts",
    title_item: "Blender Arts",
    description: "Blender Arts, YouTube-Tutorials",
    Year: "Year: 2023-2024",

    image: "/images/Arts_Blender/grib.jpg",
    images: [
      "/images/Arts_Blender/BOB.jpg",
      "/images/Arts_Blender/grib.jpg",
      // "/images/Arts_Blender/grib.mp4",
      "/video/grib.mp4",

      "/images/Arts_Blender/fabrik.gif",
      "/images/Arts_Blender/island.jpg",
      "/images/Arts_Blender/boat.jpg",
      "/images/Arts_Blender/mayak.jpg",
      "/images/Arts_Blender/mashrooms.jpg",
      "/images/Arts_Blender/treasure_island.jpg",
      "/images/Arts_Blender/conveer.gif",
      "/images/Arts_Blender/bike.jpg",
      "/images/Arts_Blender/bike_2.jpg",
      "/images/Arts_Blender/bike_3.gif",
      "/images/Arts_Blender/flowers.gif",
      "/images/Arts_Blender/Geist.jpg",
      "/images/Arts_Blender/pampkin.jpg",
      "/images/Arts_Blender/Grogo.jpg",
      "/video/Grogo.mp4",
      "/images/Arts_Blender/radio.jpg",
      "/images/Arts_Blender/small world.jpg",
    ],
    categoryId: 2,
  },

  {
    id: 3,
    title: "3DsMAX Arts",
    title_item: "3DsMAX Arts",

    description:
      "Training works from various lessons, which later turned into art. Sometimes, you go beyond the project's initial scope and strive for more. Additionally, I have included works from a 3D competition.",

    Year: "Year: 2023-2024",
    image: "/images/Arts_3DsMAX/snowBall_1.jpg",
    images: [
      "/images/Arts_3DsMAX/snowBall_1.jpg",
      "/images/Arts_3DsMAX/snowBall_2.jpg",
      "/images/Arts_3DsMAX/flying castle_1.jpg",
      "/images/Arts_3DsMAX/flying castle_2.jpg",
      "/images/Arts_3DsMAX/flying castle_3.jpg",
      "/images/Arts_3DsMAX/flying castle_4.jpg",
      "/images/Arts_3DsMAX/flying castle_5.jpg",
    ],
    categoryId: 3,
  },

  {
    id: 4,
    title: "Paint Arts",
    title_item: "Paint Arts",

    description:
      "I have had a lifelong passion for drawing and have taken part in various painting competitions, which has made painting an integral part of my life. Recently I was lucky enough to try my hand at painting on large formats using acrylics, gold leaf, silver and bronze. This experience opened up new horizons for me and allowed me to create works of art that I proudly gifted to my friends. My paintings now adorn their homes and I feel a special satisfaction knowing that my creative endeavours bring joy and inspiration to those around me.",

    Year: "Year: 2021-2024",
    image: "/images/Arts_Paint/3.jpg",
    images: [
      "/images/Arts_Paint/man and woman.jpg",
      "/images/Arts_Paint/hauses_1.jpg",
      "/images/Arts_Paint/hauses_2.jpg",
      "/images/Arts_Paint/frauen_1.jpg",
      "/images/Arts_Paint/frauen_2.jpg",
      "/images/Arts_Paint/triptych No. 3.jpg",
      "/images/Arts_Paint/triptych No. 3_2.jpg",
      "/images/Arts_Paint/cats.jpg",
      "/images/Arts_Paint/cats_2.jpg",
      "/images/Arts_Paint/3.jpg",
      "/images/Arts_Paint/3_2.jpg",
      "/images/Arts_Paint/friends.jpg",
      "/images/Arts_Paint/Golden_forest.jpg",
      "/images/Arts_Paint/Golden_forest_2.jpg",
      "/images/Arts_Paint/Golden_forest_2_2.jpg",
      "/images/Arts_Paint/DecorOut.jpg",
      "/images/Arts_Paint/elephant.jpg",
      "/images/Arts_Paint/we.jpg",
      "/images/Arts_Paint/sailboat.jpg",
      "/images/Arts_Paint/1.jpg",
      "/images/Arts_Paint/2.a.jpg",
      "/images/Arts_Paint/4.jpg",
    ],
    categoryId: 4,
  },
  {
    id: 5,
    title: "Avaloid Arts",
    title_item: "Avaloid Arts",

    description: (
      <>
        During my time at Avaloid GmbH, I was actively involved in the creation
        of 3D models and product visualizations. My role was to develop
        high-quality 3D models and visualizations that were used for brochures,
        catalogs, websites, and production. My work contributed to improving the
        visual presentation of the company's products and was an important
        element in its marketing and production efforts. You can learn more
        about Avaloid GmbH on their website:
        <a
          href="https://www.avaloid.de/"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          https://www.avaloid.de/
        </a>
      </>
    ),
    Year: "Year: 2016-2020",
    image: "/images/Arts_Avaloid/braun 6.jpg",
    images: [
      "/images/Arts_Avaloid/AV-VTI03S_2.jpg",
      "/images/Arts_Avaloid/AV-VTI05W_2.jpg",
      "/images/Arts_Avaloid/AV-VTI05W_3.jpg",
      "/images/Arts_Avaloid/set.jpg",
      "/images/Arts_Avaloid/monitor back.jpg",
      "/images/Arts_Avaloid/AV-VTI07W Perspective 2.jpg",
      "/images/Arts_Avaloid/braun 6.jpg",
      "/images/Arts_Avaloid/dunkel 2.jpg",
      "/images/Arts_Avaloid/Fotolia_45940404_XL_4.jpg",
      "/images/Arts_Avaloid/Fotolia_121789548_XL_3.jpg",
      "/images/Arts_Avaloid/Fotolia_136647847_L_5,2.jpg",
      "/images/Arts_Avaloid/Fotolia_160779966_XL_1.jpg",
      "/images/Arts_Avaloid/lampy 30.jpg",
      "/images/Arts_Avaloid/Rund.jpg",
      "/images/Arts_Avaloid/tube 3.jpg",
      "/images/Arts_Avaloid/мой рендер.jpg",
      "/images/Arts_Avaloid/neu.jpg",
      "/images/Arts_Avaloid/povorot 1.jpg",
      "/images/Arts_Avaloid/povorot 2.jpg",
      "/images/Arts_Avaloid/U2_3.jpg",
      "/images/Arts_Avaloid/U2_5.jpg",
      "/images/Arts_Avaloid/U3_1.jpg",
      "/images/Arts_Avaloid/U3_2.jpg",
      "/images/Arts_Avaloid/U3_3.jpg",
      "/images/Arts_Avaloid/SR_View 1.jpg",
      "/images/Arts_Avaloid/SR_View 4.jpg",
      "/images/Arts_Avaloid/VS-KH-01_View 1.jpg",
      "/images/Arts_Avaloid/VS-KH-01_View 4.jpg",
      "/images/Arts_Avaloid/VS-KH-02_View 1.jpg",
      "/images/Arts_Avaloid/VS-KH-03_View 1.jpg",
      "/images/Arts_Avaloid/VS-KW-01-100_View_2.jpg",
      "/images/Arts_Avaloid/VS-KW-02_View_3.jpg",
      "/images/Arts_Avaloid/VS-KW-05_View_3.jpg",
      "/images/Arts_Avaloid/VS-KW-03_View_3.jpg",
      "/images/Arts_Avaloid/wh 1.0.jpg",
      "/images/Arts_Avaloid/wh 4.0.jpg",
      "/images/Arts_Avaloid/wh 6.0.jpg",
    ],
    categoryId: 5,
  },
  {
    id: 6,
    title: "IDuet Arts",
    title_item: "IDuet Arts",

    description:
      "An attempt was made to design furniture in 3D from drawings for further production with the IDuet design team (modular wardrobe elements, tables, sofas).",

    Year: "Year: 2019",
    image: "/images/Arts_IDuet/View_02_2.jpg",
    images: [
      "/images/Arts_IDuet/stol 3 2v_3 .jpg",
      "/images/Arts_IDuet/stol 3 2v_4 .jpg",
      "/images/Arts_IDuet/View_02_2.jpg",
      "/images/Arts_IDuet/View_03_folds_.jpg",
      "/images/Arts_IDuet/section_1.jpg",
      "/images/Arts_IDuet/section_6.jpg",
      "/images/Arts_IDuet/section_7.jpg",
      "/images/Arts_IDuet/section_9.jpg",
    ],
    categoryId: 6,
  },
  {
    id: 7,
    title: "Zeichnungen Arts",
    title_item: "Zeichnungen Arts",

    description:
      "Sometimes random scribbles on a piece of paper can turn into amazing plots and characters. My job as an artist is to capture their potential and give these stories life. Through colour transformation and processing using computer or artificial intelligence, I allow these ideas to develop and unfold.\n\n" +
      "These drawings, created at different periods of my life, reflect the different stages of my creative journey. Each artwork is unique and carries a piece of my inspiration and emotions. I hope they can give you joy and inspiration, just as they do for me.",

    Year: "Year: 2000-2022",
    image: "/images/Arts_Zeichnungen/Barkasa.jpg",
    images: [
      "/images/Arts_Zeichnungen/Barkasa.jpg",
      "/images/Arts_Zeichnungen/cockroach_2.jpg",
      "/images/Arts_Zeichnungen/abyss.jpg",
      "/images/Arts_Zeichnungen/battle.jpg",
      "/images/Arts_Zeichnungen/antipode.jpg",
      "/images/Arts_Zeichnungen/antipode_2.jpg",
      "/images/Arts_Zeichnungen/cockroach.jpg",
      "/images/Arts_Zeichnungen/cow.jpg",
      "/images/Arts_Zeichnungen/cow_2.jpg",
      "/images/Arts_Zeichnungen/echidna.jpg",
      "/images/Arts_Zeichnungen/flowers.jpg",
      "/images/Arts_Zeichnungen/flowers_2.jpg",
      "/images/Arts_Zeichnungen/graveyard.jpg",
      "/images/Arts_Zeichnungen/killer.jpg",
      "/images/Arts_Zeichnungen/mansion.jpg",
      "/images/Arts_Zeichnungen/request.jpg",
      "/images/Arts_Zeichnungen/run.jpg",
      "/images/Arts_Zeichnungen/running.jpg",
      "/images/Arts_Zeichnungen/sadness.jpg",
      "/images/Arts_Zeichnungen/someone.jpg",
      "/images/Arts_Zeichnungen/Spain.jpg",
      "/images/Arts_Zeichnungen/Spain_2.jpg",
    ],
    categoryId: 7,
  },
  {
    id: 8,
    title: "OnlySmyle Arts",
    title_item: "OnlySmyle Arts",

    description:
      "OnlySmyle - teeth whitening appliance and products. Design development, 3D modelling for Amazon.",

    Year: "Year: 2022",
    image: "/images/Arts_OnlySmyle/№1 6.jpg",
    images: [
      "/images/Arts_OnlySmyle/№1 6.jpg",
      "/images/Arts_OnlySmyle/№7 5.jpg",
      "/images/Arts_OnlySmyle/set №6 2 6.jpg",
      "/images/Arts_OnlySmyle/паста №3.jpg",
      "/images/Arts_OnlySmyle/№2.jpg",
      "/images/Arts_OnlySmyle/1.jpg",
    ],
    categoryId: 8,
  },

  {
    id: 9,
    title: "Keyfaktor Arts",
    title_item: "Keyfaktor Arts",

    description: "Keyfaktor - key fob. Design development.",

    Year: "Year: 2020",
    image: "/images/Arts_Keyfaktor/luchnica.jpg",
    images: [
      "/images/Arts_Keyfaktor/kluchnica 5.jpg",
      "/images/Arts_Keyfaktor/luchnica.jpg",
      "/images/Arts_Keyfaktor/luchnica 5_VRayRawLighting.jpg",
    ],
    categoryId: 9,
  },
  {
    id: 10,
    title: "Swalby Arts",
    title_item: "Swalby Arts",

    description:
      "This is a design rendering of the `Swalby` silicone children's cookware for Amazon. ",

    Year: "Year: 2020-2021",
    image: "/images/Arts_Swalby/Swalby_2.jpg",
    images: [
      "/images/Arts_Swalby/Swalby.jpg",
      "/images/Arts_Swalby/1_grun.jpg",
      "/images/Arts_Swalby/2_grun.jpg",
      "/images/Arts_Swalby/Swalby_2.jpg",
      "/images/Arts_Swalby/Swalby_3.jpg",
      "/images/Arts_Swalby/Swalby_4.jpg",
      "/images/Arts_Swalby/Swalby_5.jpg",
    ],
    categoryId: 10,
  },
  {
    id: 11,
    title: "Tetris Arts",
    title_item: "Tetris Arts",

    description:
      "Working on updating the logo of trucking and removals. To work in 2D, we had to make tetris figures in 3D, so that they fly.",

    Year: "Year: 2020",
    image: "/images/Arts_Tetris/tetris_1.jpg",
    images: [
      "/images/Arts_Tetris/tetris_1.jpg",
      "/images/Arts_Tetris/tetris_2.jpg",
      "/images/Arts_Tetris/tetris_3.jpg",
    ],
    categoryId: 11,
  },

  {
    id: 12,
    title: "Balter Arts",
    title_item: "Balter Arts",

    description:
      "During my time at Balter GmbH, I was actively involved in the creation of 3D models and product visualisations. My role was to develop high quality 3D models and visualisations that were used for brochures, catalogues, website and production. My work contributed to improving the visual presentation of the company's products and was an important element in its marketing and production efforts.",

    Year: "Year: 2015-2020",
    image: "/images/Arts_Balter/kartinka dom2.jpg",
    images: [
      "/images/Arts_Balter/KP5_View 1 2.jpg",
      "/images/Arts_Balter/KP5_View 3 2.jpg",
      "/images/Arts_Balter/kartinka dom2.jpg",
      "/images/Arts_Balter/kamera 2B 300dpi.jpg",
      "/images/Arts_Balter/kamera 2W 300dpi.jpg",
      "/images/Arts_Balter/kamera 10 v2.jpg",
      "/images/Arts_Balter/kamera 5 n4.jpg",
      "/images/Arts_Balter/kamera6.jpg",
      "/images/Arts_Balter/kamera7.jpg",
      "/images/Arts_Balter/stoika 2.jpg",
      "/images/Arts_Balter/TS2_03.jpg",
      "/images/Arts_Balter/View_02.jpg",
      "/images/Arts_Balter/zapravka 8.jpg",
      "/images/Arts_Balter/zapravka.jpg",
      "/images/Arts_Balter/TSS.jpg",
      "/images/Arts_Balter/TSS_2.jpg",
      "/images/Arts_Balter/Stend 3_View 1.jpg",
    ],

    categoryId: 12,
  },
  {
    id: 13,
    title: "Neona Arts",
    title_item: "3D Product Animation for Floor Lamp",

    description:
      "This project is a test assignment from Neona to conceptualize and produce a short, engaging 3D animation video advertisement for a floor lamp, created in 3ds Max. The primary goal is to showcase the product's key features, aesthetic appeal, and potential application in a home environment.",

    Year: "Year: 2024",
    image: "/images/Arts_Neona/neona_1.jpg",
    images: [
      "/images/Arts_Neona/neona_1.jpg",
      "/images/Arts_Neona/neona_2.jpg",
      "/images/Arts_Neona/neona_3.jpg",
      "/video/neona-anim.mp4",
    ],

    categoryId: 13,
  },
  {
    id: 14,
    title: "labvisions Arts",
    title_item: "3D Product for labvisions",

    description:
      "A series of 3D explorations for labvisions: glass, light, and complex forms in motion and stillness. https://www.labvisions.de/",

    Year: "Year: 2024-2025",
    image: "/images/Arts_Labvisions/labvision_1.jpg",
    images: [
      "/video/Sequence 01_1.mp4",
      "/images/Arts_Labvisions/labvision_1.jpg",
      "/images/Arts_Labvisions/labvision_2.jpg",
      "/images/Arts_Labvisions/labvision_3.jpg",
      "/images/Arts_Labvisions/labvision_4.jpg",
      "/images/Arts_Labvisions/labvision_5.jpg",
      "/images/Arts_Labvisions/labvision_6.jpg",
    ],

    categoryId: 14,
  },
  {
    id: 15,
    title: "Bärga Arts",
    title_item: "3D Product - Bärga",

    description:
      "A functional kitchen mat design developed for Chinese manufacturing: durable rubber material, anti-slip texture, and ergonomic comfort for daily use.",

    Year: "Year: 2022",
    image: "/images/Arts_Bärga/Bärga_1.jpg",
    images: [
      "/images/Arts_Bärga/Bärga_1.jpg",
      "/images/Arts_Bärga/Bärga_2.jpg",
      "/images/Arts_Bärga/Bärga_3.jpg",
      "/images/Arts_Bärga/Bärga_4.jpg",
      "/images/Arts_Bärga/Bärga_5.jpg",
      "/images/Arts_Bärga/Bärga_6.jpg",
    ],

    categoryId: 15,
  },
  {
    id: 16,
    title: "Technic Arts",
    title_item: "3D Product Technic",

    description:
      "A collection of precision components for various devices — intercoms, 3D printer parts, and custom mechanical solutions, blending technical functionality with industrial aesthetics.",

    Year: "Year: 2022-2025",
    image: "/images/Arts_Technic/domofon.jpg",
    images: [
      // "/video/Sequence 01_1.mp4",
      "/images/Arts_Technic/domofon.jpg",
      // "/images/Arts_Technic/labvision_2.jpg",
      // "/images/Arts_Technic/labvision_3.jpg",
      // "/images/Arts_Technic/labvision_4.jpg",
      // "/images/Arts_Technic/labvision_5.jpg",
      // "/images/Arts_Technic/labvision_6.jpg",
    ],

    categoryId: 16,
  },
  {
    id: 17,
    title: "Corel Draw Arts",
    title_item: "Corel Draw Products",

    description:
      "A series of 3D explorations for labvisions: glass, light, and complex forms in motion and stillness. https://www.labvisions.de/",

    Year: "Year: 2026",
    image: "/images/Arts_CorelDraw/Logo_Dance.jpg",
    images: ["/images/Arts_CorelDraw/Logo_Dance.jpg"],

    categoryId: 17,
  },
];

export default arts;
